/* eslint-disable prettier/prettier */
import { colors } from '&assets/constants/colors';
import { device } from '&assets/constants/responsiveness';
import styled from 'styled-components';

const themeColors = [
	'rgba(239, 239, 242, 1)',
	'rgba(233, 233, 229, 1)',
	'rgba(237, 248, 239, 1)',
	'rgba(195, 234, 227, 1)',
];

interface Props {
	index: number;
}

export const ThemeWrapper = styled.div<Props>`
	.MuiAccordion-rounded.Mui-expanded {
		background: ${(props) => themeColors[props.index % 4]};
	}
	.MuiAccordion-root,
	.MuiAccordion-rounded {
		background: ${(props) => themeColors[props.index % 4]};
	}
	.read-more {
		border: 1px solid
			${(props) => (props.index % 4 === 0 ? 'white' : colors.primary)} !important;
	}
`;

export const ChallengeWrapper = styled.div`
	min-height: 300px;
	max-height: fit-content;
	box-sizing: border-box;
	width: 100%;
	background-color: ${colors.white};
	.loading-center {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 20px;
		.MuiCircularProgress-colorInherit {
			color: ${colors.primary};
		}
	}
	.content {
		height: 100%;
		padding: 50px 0px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		.MuiAccordion-root,
		.MuiAccordion-rounded {
			box-shadow: none !important;
			border-top: 1px solid ${colors.textDark};
			&:last-of-type {
				border-bottom-left-radius: 0;
				border-bottom-right-radius: 0;
			}
			&:first-of-type {
				border-top-left-radius: 0;
				border-top-right-radius: 0;
			}
		}
		.MuiAccordion-rounded.Mui-expanded {
			border-top: 1px solid ${colors.primary} !important;
			.accordion-title {
				font-family: 'Segnifier-Regular';
				color: ${colors.primary};
				font-size: 36px;
				text-align: center;
				width: 100%;
				margin: 20px;
			}
		}
		.accordion-body {
			padding: 0px 50px;
			box-sizing: border-box;
			width: 100%;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			.theme-details-text {
				padding: 50px 0;
				box-sizing: border-box;

				.accordion-content {
					display: flex;
					flex-direction: column;
					margin: 0;
					color: #37494b;
					font-size: 20px;
					font-style: normal;
					font-weight: 400;
					line-height: 28px;
					letter-spacing: -0.6px;
					margin-bottom: 24px;
				}
			}
			.theme-details-img {
			}
		}
		.title {
			color: ${colors.black};
			font-size: 49.563px;
			width: 60%;
			font-family: 'Segnifier-Regular';
			margin-bottom: 55px;
		}
		.description {
			font-size: 1rem;
			line-height: 1.5rem;
			color: ${colors.textDark};
			margin: 0;
			margin-bottom: 55px;
		}
		.accordion-title {
			font-family: 'Segnifier-Regular';
			color: ${colors.textDark};
			font-size: 36px;
			text-align: center;
			width: 100%;
			margin: 20px;
		}
		.apply-now {
			align-self: flex-end;
			margin-top: 20px;
		}
	}
	@media ${device.tablet} {
		.content {
			padding: 20px;
			.title {
				width: auto;
				font-size: 2.75rem;
				margin-bottom: 30px;
			}
			.accordion-title {
				font-size: 2rem;
			}
			.accordion-content {
				font-size: 1.5rem;
				line-height: 35px;
			}
			.accordion-body {
				padding: 0px 10px;
				box-sizing: border-box;
				width: 100%;
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				.theme-details-text {
					width: 100%;
					padding: 50px 0;
					box-sizing: border-box;
					.accordion-content {
						display: flex;
						flex-direction: column;
						margin: 0;
						color: #37494b;
						font-size: 20px;
						font-style: normal;
						font-weight: 400;
						line-height: 28px;
						letter-spacing: -0.6px;
						margin-bottom: 24px;
					}
				}
			}
		}
	}
	@media ${device.mobile} {
		.content {
			padding: 20px;
			.title {
				width: auto;
				font-size: 2.75rem;
				margin-bottom: 30px;
			}
			.accordion-title {
				font-size: 1.75rem;
			}
			.accordion-content {
				font-size: 1.25rem;
				line-height: 30px;
			}
			.accordion-body {
				padding: 0px 10px;
				box-sizing: border-box;
				width: 100%;
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				.theme-details-text {
					width: 100%;
					padding: 0px 0;
					margin-top: 20px;
					.accordion-content {
						font-size: 18px;
					}
				}
			}
		}
	}
`;
